import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import Side from "../Auth/Side";
import helperSpinner from "../../../helpers/spinner";
import httpService from "../../../services/httpServices/httpServices";
import validationAddUserMarketer from "../../../validtions/forms/marketer/add-user";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

export default function AddUserByMarketerOutSidePanel() {
  const [showPassword, setShowPassword] = useState(false);
  const [userMarketer, setUserMarketer] = useState();
  const [message, setMessage] = useState();
  const history = useHistory();
  const params = useParams();
  const identityMarketer = params.identityMarketer;

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`} dir="rtl">
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    removeHeader();
    removeFooter();
    getUserMarketerInfo();
  }, []);

  const removeHeader = () => {
    const headerTag = document.querySelector(".main-header");
    if (!headerTag) {
      return;
    }
    headerTag.remove();
  };

  const removeFooter = () => {
    const headerTag = document.querySelector(".main-footer");
    if (!headerTag) {
      return;
    }
    headerTag.remove();
  };

  const getUserMarketerInfo = async () => {
    helperSpinner.showSpinner(helperSpinner.CONTAINER_AUTH_PAGE);
    const user = await sendRequestGetUserMarketerInfo();
    helperSpinner.removeSpinner(helperSpinner.CONTAINER_AUTH_PAGE);
    if (!user) {
      return;
    }
    setUserMarketer(user);
  };

  const sendRequestGetUserMarketerInfo = async () => {
    const headersRequest = getHeaderForRequest();
    let user;
    try {
      user = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/marketer/info/register-page/${identityMarketer}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return user.data.data;
  };

  const getHeaderForRequest = () => {
    return {
      headers: {
        "Content-Type": "application/json",
      },
    };
  };

  const sendRequestAddUser = async (dataForm) => {
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/marketer/add-user",
        dataForm,
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }
    return true;
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const formData = getDateForm();
    const resultValidationAddUserMarketer =
      validationAddUserMarketer.validateFormAddUser(formData);
    if (resultValidationAddUserMarketer != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: resultValidationAddUserMarketer,
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }
    helperSpinner.showSpinner(helperSpinner.CONTAINER_AUTH_PAGE);
    const resultSendRequestAddUser = await sendRequestAddUser(formData);
    helperSpinner.removeSpinner(helperSpinner.CONTAINER_AUTH_PAGE);

    if (!resultSendRequestAddUser) {
      return;
    }
    setMessage({
      type_class: "alert alert-success text-dark",
      text: "کاربر با موفقیت ثبت نام شد.",
      class_icon: "fa fa-check-circle text-dark",
    });
    setTimeout(() => {
      window.location.replace("/login");
    }, 2000);
  };

  const getDateForm = () => {
    return {
      identity_marketer: identityMarketer,
      mobile: document.querySelector("#mobile").value.trim(),
      email: document.querySelector("#email").value.trim(),
      password: document.querySelector("#password").value.trim(),
    };
  };

  const generateFromRegisterUser = () => {
    return (
      <>
        <div
          className="header-box border-radius-auth-page py-1 px-3"
          style={{ fontSize: "14px" }}
        >
          ثبت نام کاربر بوسیله کارشناس
        </div>
        <div className="body-box d-flex flex-column pt-4 pb-2 px-3">
          {messageTag}
          <div className="py-2 text-center">
            کارشناس {userMarketer.first_name} {userMarketer.last_name}
          </div>
          <form
            onSubmit={sendForm}
            className="border border-1 border-success rounded px-3"
            dir="rtl"
          >
            <div className="d-flex justify-content-center py-2">
              <input
                required
                onWheel={(event) => event.currentTarget.blur()}
                type="number"
                id="mobile"
                className="form-control form-control-hilite w-auto"
                placeholder="شماره موبایل"
              />
            </div>
            <div className="d-flex justify-content-center py-2">
              <input
                required
                type="email"
                id="email"
                className="form-control form-control-hilite w-auto"
                placeholder="ایمیل"
              />
            </div>
            <div className="d-flex justify-content-center py-2 ">
              <div
                dir="rtl"
                className="input-group w-auto position-relative"
                id="password-container-auth-page"
              >
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control form-control-hilite rounded-0"
                  id="password"
                  placeholder="کلمه عبور"
                  min="8"
                  required
                />
                <div
                  className="position-absolute hover"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowPassword((prevState) => !prevState);
                  }}
                >
                  <i
                    className={showPassword ? "fa fa-eye-slash" : "fa fa-eye"}
                  ></i>
                </div>
              </div>
            </div>
            <div className="d-flex py-3">
              <button
                type="submit"
                className="btn btn-hilite-1 w-100 border-radius-auth-page"
              >
                ثبت نام کاربر
              </button>
            </div>
          </form>
        </div>
      </>
    );
  };

  const generateUserDoseNotExist = () => {
    return (
      <div className="p-2">
        <p className="alert alert-danger">
          .کاربر بازاریابی با این شناسه وجود ندارد
        </p>
      </div>
    );
  };

  return (
    <div
      className="ltr container-fluid container-auth-page"
      id="container-auth-page"
    >
      <div className="row h-100">
        <Side />
        <div
          className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 h-lg-100 py-5 p-lg-0"
          id="container-auth-page-box"
        >
          <div className="d-flex flex-column align-items-center justify-content-center h-100">
            <div id="auth-page-box">
              <div className="border-radius-auth-page">
                {userMarketer
                  ? generateFromRegisterUser()
                  : generateUserDoseNotExist()}
              </div>
              <div className="d-flex justify-content-between pt-1">
                <span>info@hilite.ir</span>
                <span>۰۲۱-۶۶۷۵۷۳۷۹</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
